<div class="loader-wrapper">
  <div class="dimmer"></div>
  <div class="spinner-wrapper">
    <div class="html-spinner"></div>
  </div>
</div>
